import { render } from "./regularTest.vue?vue&type=template&id=7a0beabe&scoped=true"
import script from "./regularTest.vue?vue&type=script&lang=js"
export * from "./regularTest.vue?vue&type=script&lang=js"

import "./regularTest.vue?vue&type=style&index=0&id=7a0beabe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0beabe"]])

export default __exports__